import { Helmet } from 'react-helmet-async';

/**
 * Reusable SEO head component.
 * Renders title, meta description, Open Graph, Twitter card, and canonical link.
 *
 * Every tag here also duplicates a static fallback baked into
 * client/public/index.html (kept there for non-JS link-unfurling bots -
 * see the comment above those tags). react-helmet-async only manages tags
 * it renders itself, so it can't remove that static duplicate - both end up
 * in the DOM. The data-seohead marker lets the prerender job (see
 * server/jobs/prerender-cron.js) reliably strip the static one out of the
 * HTML it caches, keeping only this page-specific version.
 */
function SeoHead({ title, description, url, image, noIndex, jsonLd }) {
  return (
    <Helmet>
      <title data-seohead="true">{title}</title>
      <meta data-seohead="true" name="description" content={description} />
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta data-seohead="true" property="og:title" content={title} />
      <meta data-seohead="true" property="og:description" content={description} />
      <meta data-seohead="true" property="og:url" content={url} />
      <meta data-seohead="true" property="og:type" content="website" />
      {image && <meta data-seohead="true" property="og:image" content={image} />}
      <meta data-seohead="true" property="og:site_name" content="Naija Nest Properties" />

      {/* Twitter Card */}
      <meta data-seohead="true" name="twitter:card" content="summary_large_image" />
      <meta data-seohead="true" name="twitter:title" content={title} />
      <meta data-seohead="true" name="twitter:description" content={description} />
      {image && <meta data-seohead="true" name="twitter:image" content={image} />}

      {noIndex && <meta name="robots" content="noindex, nofollow" />}

      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}

export default SeoHead;
